import React from "react";
import { Card, Statistic } from "antd";
import { TeamOutlined } from "@ant-design/icons";

const TotalCustomersCard = ({ value }) => {
  return (
    <Card className="dashboard-card">

      <div >


          <div className="d-flex align-items-center justify-content-between gap-2">
          <h5 className="card-title">TOTAL CUSTOMERS</h5>
          <div className="icon-box purple">
          
          <TeamOutlined  />
        </div>
          </div>
          
          <Statistic
            value={value}
            precision={0}
            valueStyle={{ color: "#6f42c1", fontWeight: "bold", fontSize: "28px" }}
          />
        
      </div>
    </Card>
  );
};

export default TotalCustomersCard;
